import { withAuthenticationRequired } from '@auth0/auth0-react';
import React, { useContext } from 'react';
import { Roles } from '@callmart/types';
import UserContext from '../../store/User/UserContext';
import Loader from '../Loaders/Loader';
import AccessDenied from '../../pages/AccessDenied';

type NonEmptyRoles = [Roles, ...Roles[]];

interface ProtectedRouteProps {
    component: React.ComponentType<any>;
    allowedRole?: Roles;
    allowedRoles?: NonEmptyRoles;
    allowedPermissions?: string[];

    [key: string]: any;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    component,
    allowedRole,
    allowedRoles,
    allowedPermissions = [],
    ...props
}) => {
    const loggedInUser = useContext(UserContext);

    const Component = withAuthenticationRequired(component, {
        onRedirecting: () => <Loader />,
    });

    if (!loggedInUser) {
        return <Component {...props} />;
    }

    const userRoles = loggedInUser.roles ?? [];

    const hasAllowedRoles = allowedRoles !== undefined;
    const requiredRoles = hasAllowedRoles ? allowedRoles : allowedRole ? [allowedRole] : [];
    const hasRequiredRole =
        hasAllowedRoles || allowedRole ? requiredRoles.some((role) => userRoles.includes(role)) : true;

    const hasRequiredPermissions =
        allowedPermissions.length > 0
            ? allowedPermissions.every((permission) => loggedInUser.permissions?.includes(permission))
            : true;

    if (!loggedInUser.isCallmartUser || !hasRequiredRole || !hasRequiredPermissions) {
        return <AccessDenied />;
    }

    return <Component {...props} />;
};

export default ProtectedRoute;
